import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import { FaAws } from "react-icons/fa";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiNextdotjs,
  SiPostgresql,
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiKubernetes,
  SiDocker,
  SiAwslambda, 
  SiTerraform,
  SiAnsible,
  SiRedhat,
  SiUbuntu,
  SiLinux
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  const techs = [
    { icon: <CgCPlusPlus />, name: "C++" },
    { icon: <DiJavascript1 />, name: "JavaScript" },
    { icon: <TbBrandGolang />, name: "GoLang" },
    { icon: <DiNodejs />, name: "Node.js" },
    { icon: <DiReact />, name: "React" },
    { icon: <SiDocker />, name: "Docker" },
    { icon: <SiAwslambda />, name: "AWS Lambda" },
    { icon: <SiNextdotjs />, name: "Next.js" },
    { icon: <DiGit />, name: "Git" },
    { icon: <SiFirebase />, name: "Firebase" },
    { icon: <SiRedis />, name: "Redis" },
    { icon: <SiPostgresql />, name: "PostgreSQL" },
    { icon: <DiPython />, name: "Python" },
    { icon: <DiJava />, name: "Java" },
    { icon: <SiKubernetes />, name: "Kubernetes" },
    { icon: <SiVisualstudiocode />, name: "VS Code" },
    { icon: <SiPostman />, name: "Postman" },
    { icon: <SiSlack />, name: "Slack" },
    { icon: <SiVercel />, name: "Vercel" },
    { icon: <FaAws />, name: "AWS" },
    { icon: <SiTerraform />, name: "Terraform" },
    { icon: <SiAnsible />, name: "Ansible" },
    { icon: <SiRedhat />, name: "RedHat" },
    { icon: <SiUbuntu />, name: "Ubuntu" },
    { icon: <SiLinux />, name: "Linux" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {techs.map((tech, idx) => (
        <Col xs={4} md={2} className="tech-icons" key={idx}>
          <div style={{ textAlign: "center" }}>
            {tech.icon}
            <p style={{ marginTop: "8px", fontSize: "0.9rem", color: "white" }}>
              {tech.name}
            </p>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
